import {
    AnonRoutes,
    AuthedRoutes,
    AdminRoutes,
    Login,
    Logout,
    PasswordResetRequest,
    PasswordReset,
    Project,
    Song,
    Projects,
    ReviewDropboxSyncs,
    DropboxSync,
    ImportTaxonomy,
    ManageTaxonomy,
    ManageClient,
    ManageProject,
    ObjectList,
    TaxonomyList,
    AdminDashboard,
    CreateSync,
    LoadLastURL,
    ManageExportFormat,
    ManageUILayout,
    ManageMLModel,
    TaggerManager,
    MLManager,
    SongsByClient,
} from 'pages';

const routes = [
    {
        element: <AnonRoutes />,
        children: [
            {
                path: 'login',
                element: <Login />,
            },
            {
                path: 'logout',
                element: <Logout />,
            },
            {
                path: 'password_reset_request',
                element: <PasswordResetRequest />,
            },
            {
                path: 'password_reset/:code',
                element: <PasswordReset />,
            },
            {
                path: 'load_last_url',
                element: <LoadLastURL />,
            },
        ],
    },
    {
        path: '',
        element: <AuthedRoutes />,
        children: [
            {
                index: true,
                element: <Projects />,
            },
            {
                path: 'project/:id/',
                element: <Project />,
            },
            {
                path: 'project/:id/:split',
                element: <Project />,
            },
            {
                path: 'project/:id/add_songs',
                element: <CreateSync />,
            },
            {
                path: 'song/:id',
                element: <Song />,
            },
            {
                path: 'song/:id/:split',
                element: <Song />,
            },
            {
                path: 'review_dropbox_syncs/:project_id?',
                element: <ReviewDropboxSyncs />,
            },
            {
                path: 'dropbox_sync/:id',
                element: <DropboxSync />,
            },

            {
                path: 'manage_taggers',
                element: <TaggerManager />,
            },
        ],
    },
    {
        path: 'admin',
        element: <AuthedRoutes />,
        children: [
            {
                index: true,
                element: <AdminDashboard />,
            },
            {
                path: 'import_taxonomy',
                element: <ImportTaxonomy />,
            },
            {
                path: 'taxonomy/:id?',
                element: <ManageTaxonomy />,
            },
            {
                path: 'exportformat',
                element: <ManageExportFormat />,
            },
            {
                path: 'exportformat/:id?',
                element: <ManageExportFormat />,
            },
            {
                path: 'client/:id?',
                element: <ManageClient />,
            },
            {
                path: 'project/:id?',
                element: <ManageProject />,
            },
            {
                path: 'home/client',
                element: (
                    <ObjectList
                        app={'home'}
                        modelname={'client'}
                        scoping={'?owners='}
                    />
                ),
            },
            {
                path: 'home/taxonomy',
                element: (
                    <TaxonomyList
                        app={'home'}
                        modelname={'taxonomy'}
                        scoping={'?clients__owners='}
                    />
                ),
            },
            {
                path: 'home/exportformat',
                element: (
                    <ObjectList
                        app={'home'}
                        modelname={'exportformat'}
                        scoping={'?taxonomy__clients__owners='}
                    />
                ),
            },
            {
                path: 'songs_by_client/',
                element: <SongsByClient />,
            },
        ],
    },
    {
        path: 'admin',
        element: <AdminRoutes />,
        children: [
            {
                path: 'manage_ml',
                element: <MLManager />,
            },
            {
                path: 'uilayout/:id?',
                element: <ManageUILayout />,
            },
            {
                path: 'mlmodel/:id?',
                element: <ManageMLModel />,
            },
            {
                path: ':app/:modelname',
                element: <ObjectList />,
            },
        ],
    },
];

export default routes;
